import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './modules/types'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    locale: 'en',
    username: '',
    memberId: 0,
    avatar: '',
    roleType: '',
    sectionTeacher: false,
    fileUploadProgress: {},
    forceBack: false,
    auths: [],
    routes: [],
    logo: '',
    smallLogo: '',
  },
  getters: {
    getProgress: state => {
      return state.fileUploadProgress
    },
  },
  mutations: {
    changeLocale(state, payload: string) {
      state.locale = payload
    },
    setRoleType(state, payload: string) {
      state.roleType = payload
    },
    setSectionTeacher(state, payload: boolean) {
      state.sectionTeacher = payload
    },
    setUserInfo(state, payload: { username: string; memberId: number; avatar: string }) {
      const { username, avatar, memberId } = payload
      state.username = username
      state.memberId = memberId
      state.avatar = avatar
    },
    setFileUploadProgress(state, payload: { key: string; progress: number }) {
      const { key, progress } = payload
      Vue.set(state.fileUploadProgress, key, progress)
    },
    changeForceBack(state, payload: boolean) {
      state.forceBack = payload
    },
    setAuths(state, payload) {
      state.auths = payload
    },
    setRoutes(state, payload) {
      state.routes = payload
    },
    removeAuths(state) {
      state.auths = []
    },
    removeRoutes(state) {
      state.routes = []
    },
    setLogo(state, payload) {
      const { logo, smallLogo } = payload
      state.logo = logo
      state.smallLogo = smallLogo
    },
  },
  actions: {
    refreshRoutes({ commit }) {
      commit('removeAuths')
      commit('removeRoutes')
    },
  },
  modules: {},
}

export default new Vuex.Store<RootState>(store)
